import { useState, useEffect } from "react";
import { categoriesAPI } from "../services/api";

/**
 * Hook para obtener todas las categorías
 * @returns {Object} Estado de categorías
 */
export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const data = await categoriesAPI.getAll();
      setCategories(data);
      setError(null);
    } catch (err) {
      setError("Error al cargar categorías");
      console.error("Error fetching categories:", err);
    } finally {
      setLoading(false);
    }
  };

  return {
    categories,
    loading,
    error,
    refetch: fetchCategories,
  };
};

/**
 * Hook para obtener una categoría específica y sus trámites
 * @param {string} categorySlug - Slug de la categoría
 * @returns {Object} Estado de categoría y trámites
 */
export const useCategoryDetail = (categorySlug) => {
  const [category, setCategory] = useState(null);
  const [tramites, setTramites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (categorySlug) {
      fetchCategoryDetail();
      fetchTramites();
    }
  }, [categorySlug]);

  /**
   * Obtiene detalles de la categoría
   */
  const fetchCategoryDetail = async () => {
    try {
      const data = await categoriesAPI.getBySlug(categorySlug);
      setCategory(data);
      setError(null);
    } catch (err) {
      setError("Error al cargar categoría");
      console.error("Error fetching category:", err);
    }
  };

  /**
   * Obtiene trámites de la categoría
   */
  const fetchTramites = async () => {
    try {
      const data = await categoriesAPI.getTramites(categorySlug);
      setTramites(data);
      setError(null);
    } catch (err) {
      setError("Error al cargar trámites");
      console.error("Error fetching tramites:", err);
    } finally {
      setLoading(false);
    }
  };

  return {
    category,
    tramites,
    loading,
    error,
    refetch: () => {
      fetchCategoryDetail();
      fetchTramites();
    },
  };
};
